<div
  animate.enter="animate-down"
  animate.leave="animate-up"
  class="w-full min-h-screen rounded-xl flex flex-col items-center justify-center relative"
>
  <div class="-top-4 -left-6 absolute">
    <!-- <button
        [routerLink]="['', 'home']"
        class="bg-gray-100 p-0.5 text-gray-100 rounded-xl"
      >
        <div
          class="py-1.5 pl-2.5 pr-3 bg-white hover:bg-gray-100/50 rounded-xl flex items-center gap-1.5"
        >
          <mat-icon svgIcon="home"></mat-icon>
          {{ "Home" | concat | translate }}
        </div>
      </button> -->
  </div>
  <div class="login-emblem-wrap">
    <span class="login-emblem-ring"></span>
    <span class="login-emblem-ring login-emblem-ring--2"></span>
    <img src="assets/images/emblem.png" class="login-emblem" alt="" />
  </div>
  <div class="login-eyebrow">
    <span class="dot"></span>
    Welcome back
  </div>
  <h1 class="login-headline">
    Access your <span class="accent">meeting</span> space
  </h1>
  <p class="login-sub">
    Enter your credentials to start connecting and collaborating securely.
  </p>


  <div class="w-full mt-3">
    <form
      (ngSubmit)="login(form.value)"
      [formGroup]="form"
      autocomplete="off"
      novalidate
    >
      <mat-form-field appearance="outline">
        <mat-label>{{ "Email Address" | concat | translate }}</mat-label>
        <input type="email" matInput formControlName="username" />
        <mat-icon matIconPrefix>email</mat-icon>
        <mat-error>
          @if (!form.get('username')?.valid && form.get('username')?.touched) {
          <span>{{ "Field is required" | concat | translate }}</span>
          }
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ "Password" | concat | translate }}</mat-label>
        <input
          [type]="hide ? 'password' : 'text'"
          matInput
          formControlName="password"
        />
        <mat-icon matIconPrefix>lock</mat-icon>
        <button
          type="button"
          mat-icon-button
          matSuffix
          (click)="hide = !hide"
          [attr.aria-label]="'Hide'"
          [attr.aria-pressed]="hide"
        >
          <mat-icon class="material-icons-outlined"
            >{{ hide ? "visibility_off" : "visibility" }}
          </mat-icon>
        </button>
        <mat-error>
          @if(!form.get('password')?.valid && form.get('password')?.touched){
          <span>
            {{ "Field is required" | concat | translate }}
          </span>
          }
        </mat-error>
      </mat-form-field>

      <div class="w-full text-end -translate-y-4">
        <p class="text-sm md:text-md text-gray-dark">
          <a routerLink="/auth/forgot-password" class="text-primary">
            {{ "Forgot Your Password" | concat | translate }}?
          </a>
        </p>
      </div>

      <div class="w-full mb-3">
        <button
          type="submit"
          [disabled]="!form.valid || loading"
          class="login-cta">
          <span>{{ loading ? 'Signing in…' : ('Login' | concat | translate) }}</span>
          <mat-icon>arrow_forward</mat-icon>
        </button>
      </div>
      <div class="w-full mt-2 text-center">
        <p class="text-sm md:text-md text-gray-dark">
          {{ "Do you not have an account yet" | concat | translate }}?
          <a routerLink="/auth/register" class="text-primary font-bold">
            {{ "Register instead." | concat | translate }}
          </a>
        </p>
      </div>
    </form>

    <div class="flex flex-col gap-4 w-full py-4 px-2">
      <div class="login-divider">
        <span>or continue with</span>
      </div>
      <button (click)="navigateTo(['auth','login-with-gms'])"
        appRipple
        class="login-social"
      >
        <mat-icon>mail</mat-icon>
        <div>Sign in with GMS</div>
      </button>
      <!-- <button
        appRipple
        class="border border-primary-300 hover:bg-primary-50 transition-all duration-300 ease-in-out rounded-md flex gap-2 py-3 items-center justify-center"
      >
        <div>Sign In With LDAP</div>
      </button> -->

      <a [href]="googleSignInUrl"
      class="login-social"
      appRipple
      >
        <mat-icon svgIcon="google"></mat-icon>
        <div>Sign in with Google</div>
      </a>

      <div class="login-foot">
        <mat-icon>shield</mat-icon>
        <span>Protected by Ngao</span>
      </div>
      <!-- <button
      (click)="onGoogleSocialLogin()"
        appRipple
        class="border border-primary-300 hover:bg-primary-50 rounded-md flex gap-2 py-3 items-center justify-center"
      >
        <mat-icon svgIcon="google"></mat-icon>
        <div>Sign In With Google</div>
      </button> -->
    </div>
  </div>
</div>
